export function track(name, params = {}) {
  if (window.gtag) {
    window.gtag('event', name, params);
  }
}